import type { PortfolioDetail } from '~/data/generated/model';
import { notEmpty } from '~/utils/types';

const getRegionsFromPortfolio = (portfoliosFromApi: PortfolioDetail[]) => {
  const mappedRegions = portfoliosFromApi.flatMap((portfolio) => {
    const { properties } = portfolio;
    if (!properties) {
      return [];
    }
    const regions = properties.map((property) => property.region);

    return regions;
  });

  return [...new Set(mappedRegions.filter(notEmpty))];
};

export default getRegionsFromPortfolio;
